
/**
 * Internal dependencies
 */
import Request from './lib/util/request';
import Connection from './lib/connection';
import requestHandler from './lib/util/fetch-request';
import Authentication from './lib/authentication';
import Preferences from './lib/preferences';
import ConnectionType from './lib/connection-type';
import Resource from './lib/resource';
import ResourceConnect from './lib/resource-connect';
import Operation from './lib/operation';
import Location from './lib/location';
import LocationGroup from './lib/location-group';
import LocationWebsite from './lib/location-website';
import UserFtp from './lib/user-ftp';
import Terminal from './lib/terminal';
import WeblinkGroup from './lib/weblink-group';
import PayType from './lib/paytype';
import ConnectionLocation from './lib/connection-location';
import ConnectionWebhooks from './lib/connection-webhooks';
import ConnectionPaymentTypes from './lib/connection-payment-types';
import ConnectionRetailerSalesTypes from './lib/connection-retailer-sales-types';
import ConnectionRetailerPayTypes from './lib/connection-retailer-pay-types';
import ConnectionSalesTypes from './lib/connection-sales-types';
import Images from './lib/images';

function CustomerEcSDK(token) {
	if (!(this instanceof CustomerEcSDK)) {
		return new CustomerEcSDK(token);
	}

	if (token) {
		this.token = token;
	} 

	this.request = function(params, fn) {
		params = params || {};
		// token is optional
		if (this.token) {
			params.authToken = this.token;
		}

		return requestHandler(params, fn);
	};

	// Add Req instance
	this.req = new Request(this);
}

CustomerEcSDK.prototype.authentication = function() {
    return new Authentication(this);
};


CustomerEcSDK.prototype.preferences = function() {
	return new Preferences(this);
};

CustomerEcSDK.prototype.userFtp = function() {
    return new UserFtp(this);
};

CustomerEcSDK.prototype.connection = function(id) {
	return new Connection(id, this);
};

CustomerEcSDK.prototype.connectionType = function(id) {
    return new ConnectionType(id, this);
};

CustomerEcSDK.prototype.resource = function(id) {
    return new Resource(id, this);
};

CustomerEcSDK.prototype.resourceConnect = function(id) {
	return new ResourceConnect(id, this);
};

CustomerEcSDK.prototype.operation = function(id) {
    return new Operation(id, this);
};

CustomerEcSDK.prototype.location = function(id) {
    return new Location(id, this);
};

CustomerEcSDK.prototype.locationGroup = function(id) {
    return new LocationGroup(id, this);
};

CustomerEcSDK.prototype.locationWebsite = function(id) {
    return new LocationWebsite(id, this);
};

CustomerEcSDK.prototype.terminal = function() {
    return new Terminal(this);
};

CustomerEcSDK.prototype.weblinkGroup = function() {
    return new WeblinkGroup(this);
};

CustomerEcSDK.prototype.paytype = function() {
    return new PayType(this);
};

CustomerEcSDK.prototype.connectionLocation = function(id) {
    return new ConnectionLocation(id, this);
};

CustomerEcSDK.prototype.images = function(id) {
	return new Images(id, this);
};

CustomerEcSDK.prototype.connectionWebhooks = function(id) {
    return new ConnectionWebhooks(id, this);
};

CustomerEcSDK.prototype.connectionPaymentTypes = function(id) {
    return new ConnectionPaymentTypes(id, this);
};

CustomerEcSDK.prototype.connectionRetailerSalesTypes = function(id) {
    return new ConnectionRetailerSalesTypes(id, this);
};

CustomerEcSDK.prototype.connectionRetailerPayTypes = function(id) {
    return new ConnectionRetailerPayTypes(id, this);
};

CustomerEcSDK.prototype.connectionSalesTypes = function(id) {
    return new ConnectionSalesTypes(id, this);
};

CustomerEcSDK.Request = Request;

let cecSDK;

if (!cecSDK) {
	cecSDK = CustomerEcSDK();
}

export default cecSDK;
